<ng-container *ngIf="!isMobile; else mobileView">
  <ion-grid class="tablet-common-grid">
    <ion-row no-padding no-margin>
      <ion-col no-padding>
        <ion-content #content (ionScroll)="onScroll($event)" class="" scrollEvents="true">
          <div class="sb-sticky">
            <sb-simple-navbar theme="sportbook" [hasBackButton]="true">
              <div
                class="sb-calendar-navbar"
                [class.is-selected]="daySelected === day?.dayDifference"
                [ngClass]="{'rebranding': globalVars.FEATURES?.MSO_NewReBranding}"
                *ngFor="let day of days"
                tappable
                (click)="changeDay(day?.dayDifference)"
              >
                <p
                  class="sb-calendar-navbar--day"
                  [ngClass]="{ 'color-primary': daySelected === day?.dayDifference, 'color-light': daySelected !== day?.dayDifference  }"
                >
                  {{ day?.title }}
                </p>
                <p
                  class="sb-calendar-navbar--date"
                  [ngClass]="{ 'color-primary': daySelected === day?.dayDifference, 'color-light': daySelected !== day?.dayDifference  }"
                >
                  {{ day?.label }}
                </p>
              </div>
            </sb-simple-navbar>
            <sb-tabs-categories
              [color]="'regular'"
              [scrollable]="true"
              [isMobile]="isMobile"
              [smallButton]="!isMobile"
              [categories]="sportsFilters"
              [selectedTab]="selectedSport"
              (selectTab)="changeSport($event)"
            ></sb-tabs-categories>
          </div>
          <ion-accordion-group #accordionGroup [multiple]="true" [value]="selectedEvents" (ionChange)="selectedLeagueChange($event)" *ngIf="todayLeagues?.length > 0">
            <ion-accordion *ngFor="let league of todayLeagues; trackBy:identify" [value]="league?.NodeId" lines="none">
              <ion-item slot="header" color="light" class="accordion--item ion-item-title small" lines="none">
                <ion-label class="accordion--item-label">
                  <p>{{ league?.Name }}</p>
                  <ion-avatar item-left class="accordion--item-label-flag">
                    <img src="assets/global/img/banderas/ICO_{{ league?.CountryCode }}.png" />
                  </ion-avatar>
                </ion-label>
                <ion-icon
                  class="accordion--item-label-icon ion-accordion-toggle-icon"
                  name="chevron-forward-outline"
                  slot="start"
                ></ion-icon>
              </ion-item>

              <div slot="content">
                <ng-container *ngIf="league?.Events?.length > 0">
                  <sb-grid-item
                    *ngFor="let event of league?.Events"
                    [event]="event"
                    [mode]="event?.mode"
                    (navigate)="navigate($event)"
                    [hasBets]="event?.sixPack?.combinedResults?.length > 0"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                      event?.mode === 'teams' ? teams : expanded;
                      context: { event: event }
                    "
                      content
                    >
                    </ng-container>

                    <sb-overview-score-sets
                      *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.SETS"
                      [sportHandle]="event?.SportHandle"
                      [scoreboard]="event?.liveData"
                      scoreboard
                    >
                    </sb-overview-score-sets>

                    <sb-overview-score-regular
                      *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.REGULAR"
                      [scoreboard]="event?.liveData"
                      scoreboard
                    >
                    </sb-overview-score-regular>

                    <div
                      class="sb-grid-item--bets-group"
                      [ngClass]="'has-' + event?.Games?.length + '-groups'"
                      [class.has-callback]="
                      event?.Games?.length % 4 !== 0 &&
                      event?.Games?.length % 2 !== 0
                    "
                      *ngFor="let game of event?.Games"
                      [betType]="game?.DisplayTypeName"
                      [desktop]="isDesktop"
                      sb-markets
                      bet-display
                    >
                      <sb-button
                        *ngFor="let result of game?.Results; let index = index"
                        [type]="game?.GameType"
                        [typeName]="game?.DisplayTypeName"
                        [game]="result"
                        [results]="game?.Results"
                        [locked]="result?.Locked"
                        [index]="index"
                        (bet)="bet($event, event, game?.Name, '1')"
                        [selected]="newTicketFacade?.hasResult(result?.NodeId)"
                        [home]="event?.teamHome"
                        [away]="event?.teamAway"
                        [sport]="event?.SportHandle"
                      >
                      </sb-button>
                    </div>
                    <sb-counter
                      *ngIf="!!event?.ChildrenCount && event?.mode !== 'expanded'"
                      [count]="event?.ChildrenCount"
                      (click)="navigate(event)"
                      counter-button
                    >
                    </sb-counter>
                  </sb-grid-item>
                </ng-container>
              </div>
            </ion-accordion>
          </ion-accordion-group>

          <h4 *ngIf="!todayLeagues?.length" class="sb-calendar--empty-state color-dark">
            No hay ningún evento de este tipo para el día seleccionado
          </h4>
          <codere-footer></codere-footer>
        </ion-content>
        <!--Overview Pages-->
        <ng-template #teams let-event="event" content>
          <sb-grid-content-teams [event]="event" content></sb-grid-content-teams>
        </ng-template>
        <ng-template #expanded let-event="event" content>
          <sb-grid-content-expanded [title]="event?.Name" [date]="event?.StartDate | sportsExtractDate" content>
          </sb-grid-content-expanded>
        </ng-template>

      </ion-col>
    </ion-row>
  </ion-grid>
</ng-container>

<ng-template #mobileView>
  <ion-header>
    <codere-navbar></codere-navbar>
    <sb-simple-navbar theme="sportbook" [hasBackButton]="true" [fakeButton]="true">
      <div
        class="sb-calendar-navbar"
        [class.is-selected]="daySelected === day?.dayDifference"
        *ngFor="let day of days"
        tappable
        (click)="changeDay(day?.dayDifference)"
      >
        <p
          class="sb-calendar-navbar--day"
          [ngClass]="{ 'color-primary': daySelected === day?.dayDifference, 'color-light': daySelected !== day?.dayDifference  }"
        >
          {{ day?.title }}
        </p>
        <p
          class="sb-calendar-navbar--date"
          [ngClass]="{ 'color-primary': daySelected === day?.dayDifference, 'color-light': daySelected !== day?.dayDifference  }"
        >
          {{ day?.label }}
        </p>
      </div>
    </sb-simple-navbar>
    <sb-tabs-categories
      [color]="'regular'"
      [scrollable]="true"
      [isMobile]="isMobile"
      [smallButton]="!isMobile"
      [categories]="sportsFilters"
      [selectedTab]="selectedSport"
      (selectTab)="changeSport($event)"
    ></sb-tabs-categories>
  </ion-header>
  <ion-content #content (ionScroll)="onScroll($event)" [ngClass]="{'no-scroll': globalVars?.iosScrollHide}" scrollEvents="true">
    <ion-accordion-group #accordionGroup [multiple]="true" [value]="selectedEvents" (ionChange)="selectedLeagueChange($event)" *ngIf="todayLeagues?.length > 0">
      <ion-accordion *ngFor="let league of todayLeagues" trackBy:identify [value]="league?.NodeId" lines="none">
        <ion-item slot="header" color="light" class="accordion--item ion-item-title small" lines="none">
          <ion-label class="accordion--item-label">
            <p>{{ league?.Name }}</p>
            <ion-avatar item-left class="accordion--item-label-flag">
              <img src="assets/global/img/banderas/ICO_{{ league?.CountryCode }}.png" />
            </ion-avatar>
          </ion-label>
          <ion-icon
            class="accordion--item-label-icon ion-accordion-toggle-icon"
            name="chevron-forward-outline"
            slot="start"
          ></ion-icon>
        </ion-item>

        <div slot="content">
          <ng-container *ngFor="let event of league?.Events">
            <ng-container *ngIf="!event?.isSixPack">
              <sb-grid-item
                [event]="event"
                [mode]="event?.mode"
                (navigate)="navigate($event)"
                [hasBets]="event?.sixPack?.combinedResults?.length > 0"
              >
                <ng-container
                  *ngTemplateOutlet="
                event?.mode === 'teams' ? teams : expanded;
                context: { event: event }
              "
                  content
                >
                </ng-container>

                <sb-overview-score-sets
                  *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.SETS"
                  [sportHandle]="event?.SportHandle"
                  [scoreboard]="event?.liveData"
                  scoreboard
                >
                </sb-overview-score-sets>

                <sb-overview-score-regular
                  *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.REGULAR"
                  [scoreboard]="event?.liveData"
                  scoreboard
                >
                </sb-overview-score-regular>

                <div
                  class="sb-grid-item--bets-group"
                  [ngClass]="'has-' + event?.Games?.length + '-groups'"
                  [class.has-callback]="
                event?.Games?.length % 4 !== 0 &&
                event?.Games?.length % 2 !== 0
              "
                  *ngFor="let game of event?.Games"
                  [betType]="game?.DisplayTypeName"
                  [desktop]="isDesktop"
                  sb-markets
                  bet-display
                >
                  <sb-button
                    *ngFor="let result of game?.Results; let index = index"
                    [type]="game?.GameType"
                    [typeName]="game?.DisplayTypeName"
                    [game]="result"
                    [results]="game?.Results"
                    [locked]="result?.Locked"
                    [index]="index"
                    (bet)="bet($event, event, game?.Name, '1')"
                    [selected]="newTicketFacade?.hasResult(result?.NodeId)"
                    [home]="event?.teamHome"
                    [away]="event?.teamAway"
                    [sport]="event?.SportHandle"
                  >
                  </sb-button>
                </div>
              </sb-grid-item>
            </ng-container>

            <ng-container *ngIf="event?.isSixPack">
              <sb-grid-header
                [titleLeft]="'Ganador'"
                [titleCenter]="'Handicap'"
                [titleRight]="'Totales'"
                [market]="event?.sixPack"
              >
              </sb-grid-header>

              <sb-grid-item
                [mode]="event?.sixPack?.displayMode"
                [event]="event?.sixPack"
                [betType]="event?.sixPack?.DisplayTypeName"
                (navigate)="navigate(event)"
              >
                <sb-grid-content-single
                  [title]="event?.sixPack?.teamHome"
                  [subtitle]="event?.sixPack?.pitcherHome"
                  content
                >
                </sb-grid-content-single>
                <div
                  class="sb-grid-item--bets-group"
                  bet-display
                  [betType]="event?.sixPack?.DisplayTypeName"
                  sb-markets
                >
                  <sb-button
                    *ngFor="
                    let result of (event?.sixPack?.combinedResults)[0].results;
                    let indexCombinedBets = index
                  "
                    [typeName]="event?.sixPack?.DisplayTypeName"
                    [type]="result?.GameType"
                    [game]="result"
                    [isCombined]="event?.sixPack?.isCombined"
                    [results]="event?.sixPack?.GroupResults"
                    [index]="indexCombinedBets"
                    [selected]="newTicketFacade?.hasResult(result.NodeId)"
                    [locked]="result?.Locked"
                    [home]="event?.sixPack?.teamHome"
                    [away]="event?.sixPack?.teamAway"
                    [sport]="event?.SportHandle"
                    (bet)="bet($event, event, event?.Name, '2')"
                    bets
                  >
                  </sb-button>
                </div>
              </sb-grid-item>

              <sb-grid-item
                [mode]="event?.sixPack?.displayMode"
                [event]="event?.sixPack"
                [betType]="event?.sixPack?.DisplayTypeName"
                class="sb-item-container-margin-bot"
                (navigate)="navigate(event)"
              >
                <sb-grid-content-single
                  [title]="event?.sixPack?.teamAway"
                  [subtitle]="event?.sixPack?.pitcherAway"
                  content
                >
                </sb-grid-content-single>
                <div
                  class="sb-grid-item--bets-group"
                  [betType]="event?.sixPack?.DisplayTypeName"
                  bet-display
                  sb-markets
                >
                  <sb-button
                    *ngFor="
                    let result of (event?.sixPack?.combinedResults)[1].results;
                    let indexCombinedBets = index
                  "
                    [typeName]="event?.sixPack?.DisplayTypeName"
                    [type]="result?.GameType"
                    [game]="result"
                    [isCombined]="event?.sixPack?.isCombined"
                    [results]="event?.sixPack?.GroupResults"
                    [locked]="result?.Locked"
                    [index]="indexCombinedBets"
                    [selected]="newTicketFacade?.hasResult(result.NodeId)"
                    [home]="event?.sixPack?.teamHome"
                    [away]="event?.sixPack?.teamAway"
                    [sport]="event?.SportHandle"
                    (bet)="bet($event, event, event?.Name, '3')"
                    bets
                  >
                  </sb-button>
                </div>
              </sb-grid-item>
            </ng-container>
          </ng-container>
        </div>
      </ion-accordion>
    </ion-accordion-group>

    <h4 *ngIf="!todayLeagues?.length" class="sb-calendar--empty-state color-dark">
      No hay ningún evento de este tipo para el día seleccionado
    </h4>

    <codere-footer></codere-footer>
  </ion-content>

  <!--Overview Pages-->
  <ng-template #teams let-event="event" content>
    <sb-grid-content-teams [event]="event" content></sb-grid-content-teams>
  </ng-template>

  <ng-template #expanded let-event="event" content>
    <sb-grid-content-expanded [title]="event?.Name" [date]="event?.StartDate | sportsExtractDate" content>
    </sb-grid-content-expanded>
  </ng-template>
</ng-template>
